import { useState } from 'react';
import { Box, Container, Paper, Tab, Tabs, Typography } from '@mui/material';
import { ImportWizard } from '../components/importexport/ImportWizard';
import { ExcelExport } from '../components/importexport/ExcelExport';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`import-export-tabpanel-${index}`}
      aria-labelledby={`import-export-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

export function ImportExportPage() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 3 }}>
        <Typography variant="h4" gutterBottom>
          Import/Export
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Import timetables from Excel files or export existing timetables for printing and distribution
        </Typography>

        <Paper>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="import export tabs"
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab label="Import" id="import-export-tab-0" aria-controls="import-export-tabpanel-0" />
            <Tab label="Export" id="import-export-tab-1" aria-controls="import-export-tabpanel-1" />
          </Tabs>

          <TabPanel value={activeTab} index={0}>
            <ImportWizard />
          </TabPanel>

          <TabPanel value={activeTab} index={1}>
            <ExcelExport />
          </TabPanel>
        </Paper>
      </Box>
    </Container>
  );
}
